import { Fragment } from "react";
import { FontAwesome } from "../../../../../../../components/icon";
import "./Toolbar.scss";
import { Icon } from "@mui/material";

function Toolbar({ editor, isFullExtension, isAnimate, actions }) {
  return (
    <div className="ToolbarContainer d-flex justify-content-between">
      <div className="toolbar-note">
        <div
          className="icon"
          onClick={() => editor.chain().focus().toggleBold().run()}
        >
          <Icon>format_bold</Icon>
        </div>
        <div
          className="icon"
          onClick={() => editor.chain().focus().toggleItalic().run()}
        >
          <Icon>format_italic</Icon>
        </div>
        <div
          className="icon"
          onClick={() => editor.chain().focus().toggleStrike().run()}
        >
          <Icon>format_strikethrough</Icon>
        </div>
        <div className="divider"></div>
        <div
          className="icon"
          onClick={() => editor.chain().focus().toggleBulletList().run()}
        >
          <Icon>format_list_bulleted</Icon>
        </div>
        <div
          className="icon"
          onClick={() => editor.chain().focus().toggleOrderedList().run()}
        >
          <Icon>format_list_numbered</Icon>
        </div>
        <div className="divider"></div>
        <div
          className="icon"
          onClick={() => editor.chain().focus().toggleBlockquote().run()}
        >
          <Icon>format_quote</Icon>
        </div>
        <div className="divider"></div>
        <div
          className="icon"
          onClick={() => editor.chain().focus().undo().run()}
        >
          <Icon>undo</Icon>
        </div>
        <div
          className="icon"
          onClick={() => editor.chain().focus().redo().run()}
        >
          <Icon>redo</Icon>
        </div>
        <div className="divider"></div>
        {isFullExtension && (
          <Fragment>
            <div
              className="icon"
              onClick={() => editor.chain().focus().setTextAlign("left").run()}
            >
              <Icon>format_align_left</Icon>
            </div>
            <div
              className="icon"
              onClick={() =>
                editor.chain().focus().setTextAlign("center").run()
              }
            >
              <Icon>format_align_center</Icon>
            </div>
            <div
              className="icon"
              onClick={() => editor.chain().focus().setTextAlign("right").run()}
            >
              <Icon>format_align_right</Icon>
            </div>
          </Fragment>
        )}
      </div>
      <div className="d-flex">
        {isAnimate && <div className="ping-animation circle-animation" />}
        {actions &&
          actions.map(({ render, title, onClick, hidden }) =>
            !hidden ? render(title, onClick) : <></>,
          )}
      </div>
    </div>
  );
}

export { Toolbar };
